import {Component, inject} from '@angular/core';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {TranslateService} from '@ngx-translate/core';
import {NzI18nService, ru_RU, kk_KZ} from 'ng-zorro-antd/i18n';

export type AppLang = 'ru' | 'kz';
const LANG_K = 'lang';

@Component({
  selector: 'app-language-switcher',
  imports: [NzButtonComponent],
  template: `
    <div class="inline-flex gap-1">
      <button nz-button nzSize="small"
              [nzType]="current === 'ru' ? 'primary' : 'default'"
              (click)="use('ru')">РУС</button>
      <button nz-button nzSize="small"
              [nzType]="current === 'kz' ? 'primary' : 'default'"
              (click)="use('kz')">ҚАЗ</button>
    </div>
  `,
})
export class LanguageSwitcher {
  private readonly _translate = inject(TranslateService);
  private readonly _nzI18n = inject(NzI18nService);

  current: AppLang = localStorage.getItem(LANG_K)?.toLowerCase() === 'kz' ? 'kz' : 'ru';

  use(lang: AppLang): void {
    if (lang === this.current) return;
    this.current = lang;
    localStorage.setItem(LANG_K, lang);
    this._translate.use(lang);
    this._nzI18n.setLocale(lang === 'kz' ? kk_KZ : ru_RU);
  }
}
